import GoodsList from "pages/\bGoodsList";
import FindAccount from "pages/FindAccount";
import FindPassword from "pages/FindPassword";
import Home from "pages/Home";
import Introduction from "pages/Introduction";
import Join from "pages/Join";
import Login from "pages/Login";
import Detail from "pages/Detail";
import Mypage from "pages/Mypage";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Introduction />} />
        <Route path="/join" element={<Join />} />
        <Route path="/main" element={<Home />} />
        <Route path="/goods" element={<GoodsList />} />
        <Route path="/detail" element={<Detail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/mypage" element={<Mypage />} />
        <Route path="/find/account" element={<FindAccount />} />
        <Route path="/find/password" element={<FindPassword />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
